import axios from 'axios'
import store from './../../store'

const baseURL = 'https://diariodetreino.agilesaas.sbs/api'
// const baseURL = 'http://localhost:8000/api'

let axiosApi = axios.create(
  {
    baseURL,
  },
  5000,
)
axiosApi.interceptors.request.use(
  (config) => {
    // 🔍 Log do que está sendo enviado pelo axios
    if (config.url && config.url.includes('day-mounted-update')) {
      console.log('🔥 [AXIOS INTERCEPTOR] URL:', config.url)
      console.log('🔥 [AXIOS INTERCEPTOR] Method:', config.method)
      console.log('🔥 [AXIOS INTERCEPTOR] config.data ANTES:', JSON.stringify(config.data, null, 2))
    }

    let token = store.getters.ApiToken
    //config.headers['Cache-Control'] = 'no-cache'
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }

    let studentId = store.getters.StudentManager
    if (studentId) {
      config.headers['student-manager'] = btoa(studentId)
    }

    let coachId = store.getters.CoachManager
    if (coachId) {
      config.headers['coach-manager'] = btoa(coachId)
    }

    let trainingPlanId = store.getters.TrainingPlanManager
    if (trainingPlanId) {
      config.headers['training-plan-manager'] = btoa(trainingPlanId)
    }

    if (config.url && config.url.includes('day-mounted-update')) {
      console.log('🔥 [AXIOS INTERCEPTOR] config.data DEPOIS:', JSON.stringify(config.data, null, 2))
    }

    return config
  },

  (error) => {
    store.commit('SET_SPLASH_SCREEN', false)
    return Promise.reject(error)
  },
)

export default axiosApi
